// @flow

import _ from "lodash";
import React, { Component } from "react";
import "./App.css";
import queryString from "query-string";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardHeader";
import Toolbar from "@material-ui/core/Toolbar";
import AppBar from "@material-ui/core/AppBar";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { withStyles } from "@material-ui/core/styles";
import { Observable } from "rxjs";

import { Adease } from "adease-sdk";

import Beaconing from "../Beaconing/index";
import AdInfo from "../AdInfo/index";
import Typography from "@material-ui/core/Typography";

import VideoPlayerSelector, {
  PlayerVanilla,
  PlayerTheoplayer,
  PlayerNexPlayer,
  PlayerBitmovin
} from "./Players/Selector";

import logo from "../ad_ease_white.png";

const styles = theme => ({
  root: {},
  gridLeft: {
    paddingTop: theme.spacing.unit,
    paddingLeft: theme.spacing.unit
  },
  gridRight: {
    paddingTop: theme.spacing.unit,
    paddingLeft: theme.spacing.unit,
    paddingRight: theme.spacing.unit,
    marginBottom: "100px"
  },
  icon: {
    marginLeft: theme.spacing.unit,
    width: theme.typography.fontSize
  },
  moreInfoButton: {
    marginBottom: theme.spacing.unit
  },
  card: {
    marginBottom: theme.spacing.unit
  },
  logoImage: {
    height: "1.9em",
    marginRight: theme.spacing.unit
  },
  appBar: {
    boxShadow: "none",
    backgroundColor: "#444",
    color: "white"
  },
  footer: {
    backgroundColor: "#444",
    bottom: 0,
    top: "unset"
  },
  toolbarFooter: {
    justifyContent: "space-between"
  },
  footerLogo: {
    height: "1.9em"
  },
  cardPlayerPicker: {
    marginTop: theme.spacing.unit
  },
  cardVideoPicker: {
    marginTop: theme.spacing.unit
  },
  videoURLRadioGroup: {
    marginLeft: theme.spacing.unit
  }
});

const pointInTimeEvents = [
  "impression",
  "start",
  "firstQuartile",
  "midpoint",
  "thirdQuartile",
  "complete"
];

const ConfigURLs = {
  telaria:
    "https://adease-api-prod.switch.tv/268/playback/getUniversalPlayerConfig?videoID=303-telaria",
  standard:
    "https://adease-api-prod.switch.tv/268/playback/getUniversalPlayerConfig?videoID=303"
};

export type Beacon = {
  trackingURL: string,
  kind: string,
  sent: boolean,
  startTime: number,
  endTime: number
};

type Props = {
  classes: any,
  match: {
    params: {
      player: string
    }
  }
};

type adInfoT = {
  adDuration: number,
  adVendor: string,
  adTag: string
};

type State = {
  beacons: Array<Beacon>,
  // If this is non-empty, it means the player is showing an ad.
  clickthrough: string,
  waitingForAd: boolean,
  adInfo: adInfoT,
  manifestURL: string,
  playerKind: string,
  videoURL: string
};

class App extends Component<Props, State> {
  initPlayback: Function;
  timeUpdate: Function;
  debug: boolean;

  category: string = "all";
  configURL: string;
  serverHost: string;
  adease: Adease;
  activeAd: string;
  currentTime: number;
  timeUpdateObserver: any;
  timeUpdateObservable: any;
  timeUpdateFencingToken: number;

  initialState = {
    beacons: [],
    clickthrough: "",
    waitingForAd: true,
    adInfo: {
      adDuration: 0,
      adTag: "",
      adVendor: ""
    }
  };

  constructor(props: Props) {
    super(props);

    this.state = _.merge(this.initialState, {
      manifestURL: "",
      playerKind: PlayerVanilla,
      videoURL: ConfigURLs.standard
    });

    this.activeAd = "";
    this.currentTime = NaN;
    this.timeUpdateFencingToken = 0;

    this.adease = new Adease();

    this.initPlayback = this.initPlayback.bind(this);
    this.timeUpdate = this.timeUpdate.bind(this);

    this.timeUpdateObservable = Observable.create(observer => {
      console.log(observer);
      this.timeUpdateObserver = observer;
    });
  }

  mergeState(newState: any): void {
    this.setState(state => Object.assign({}, state, newState));
  }

  componentDidMount = () => {
    this.configure(this.state.videoURL);
  };

  componentDidUpdate = (prevProps, prevState) => {
    if (prevState.videoURL !== this.state.videoURL) {
      this.configure(this.state.videoURL);
    }

    if (prevState.manifestURL !== "" && this.state.manifestURL === "") {
      this.activeAd = "";
      this.currentTime = NaN;
    }
  };

  configure = url => {
    this.adease
      .configureFromURL(url)
      .then(() => this.adease.getStreams())
      .then(_.first)
      .then(stream => stream.url)
      .then(this.initPlayback);
  };

  handleVideoURLChange = event => {
    this.timeUpdateFencingToken += 1;
    this.mergeState(
      _.merge(this.initialState, {
        manifestURL: "",
        videoURL: event.target.value
      })
    );
  };

  selectPlayer = player => () => {
    this.setState({ playerKind: player });
  };

  timeUpdate(timeMs: number) {
    window.requestAnimationFrame(() => {
      if (this.timeUpdateObserver) {
        this.timeUpdateObserver.next(timeMs);
      }
    });
    this.currentTime = timeMs;

    this.adease.notifyTimeUpdate(timeMs);
    if (this.adease.getAdsAtTime(timeMs).length > 0) {
      if (this.activeAd === "") {
        const ad = _.first(this.adease.getAdsAtTime(timeMs));
        this.activeAd = ad.id;
        this.attachAdDataHandler(ad);
      }
    } else {
      this.activeAd = "";
    }
  }

  attachAdDataHandler(ad: any) {
    console.count("ad data handler");
    const qs = queryString.parse(queryString.extract(window.location.href));
    const debug = qs.debug !== undefined;

    this.debug = debug;

    if (!ad) {
      console.warn("ad wanted is not available in adease sdk");
      return;
    }
    const beacons = ad.trackingUrls
      .map(beacon => ({ ...beacon, sent: false }))
      .toJS();

    this.mergeState({
      waitingForAd: false,
      beacons: beacons
    });

    const adDuration = (ad.endTime - ad.startTime) / 1000;

    const getAdVendor = (adUniqueID: string): string => {
      return adUniqueID.split("-")[0];
    };

    this.setState(state => ({
      ...state,
      adInfo: {
        ...state.adInfo,
        adDuration: Math.round(adDuration),
        adVendor: getAdVendor(ad.id)
      }
    }));

    let subscription;
    const pinnedFencingToken = this.timeUpdateFencingToken | 0;
    const progressFn = _.throttle((evt: Event) => {
      if (pinnedFencingToken !== this.timeUpdateFencingToken) {
        console.log("fencing token mismatch, bailing");
        subscription.unsubscribe();
        return;
      }

      if (this.currentTime >= ad.startTime) {
        console.log("SEND BEACONS NOW");

        const newBeacons = this.state.beacons.map((beacon: Beacon): Beacon => {
          if (
            pointInTimeEvents.includes(beacon.kind) &&
            !beacon.sent &&
            this.currentTime >= beacon.startTime
          ) {
            // fetch(beacon.trackingURL);
            return Object.assign({}, beacon, {
              sent: true
            });
          }

          return beacon;
        });
        this.mergeState({
          beacons: newBeacons
        });

        if (this.currentTime >= ad.endTime) {
          console.log("ad finished");
          subscription.unsubscribe();
          // Disable ad mode
          this.mergeState({
            clickthrough: ""
          });
        }
      }
    }, 200);
    subscription = this.timeUpdateObservable.subscribe(progressFn);
  }

  initPlayback(url: string) {
    if (url === "") {
      console.warn("Manifest URL is empty");
      return;
    }
    this.setState({
      manifestURL: url
    });
  }

  render() {
    const { classes } = this.props;

    const playerButtonColour = player => {
      if (player === this.state.playerKind) {
        return "primary";
      }
      return "default";
    };

    const playerSelector = () => {
      if (!_.isEmpty(this.props.match.params.player)) {
        return null;
      }

      return (
        <Card className={classes.cardPlayerPicker}>
          <CardHeader title="Player" />
          <CardContent>
            <Button
              variant="raised"
              color={playerButtonColour(PlayerVanilla)}
              onClick={this.selectPlayer(PlayerVanilla)}
            >
              Default
            </Button>
            <Button
              variant="raised"
              color={playerButtonColour(PlayerTheoplayer)}
              onClick={this.selectPlayer(PlayerTheoplayer)}
            >
              THEOplayer
            </Button>
            <Button
              variant="raised"
              color={playerButtonColour(PlayerNexPlayer)}
              onClick={this.selectPlayer(PlayerNexPlayer)}
            >
              NexPlayer
            </Button>
            <Button
              variant="raised"
              color={playerButtonColour(PlayerBitmovin)}
              onClick={this.selectPlayer(PlayerBitmovin)}
            >
              Bitmovin
            </Button>
          </CardContent>
        </Card>
      );
    };

    const videoSelector = () => (
      <Card className={classes.cardVideoPicker}>
        <CardHeader title="Video" />
        <CardContent>
          <RadioGroup
            className={classes.videoURLRadioGroup}
            value={this.state.videoURL}
            onChange={this.handleVideoURLChange}
          >
            <FormControlLabel
              value={ConfigURLs.standard}
              control={<Radio />}
              label="Standard Video"
            />
            <FormControlLabel
              value={ConfigURLs.telaria}
              control={<Radio />}
              label="Telaria Test"
            />
          </RadioGroup>
        </CardContent>
      </Card>
    );

    return (
      <Grid container className={classes.root}>
        <CssBaseline />

        <AppBar position="static" className={classes.appBar}>
          <Toolbar>
            <img className={classes.logoImage} src={logo} alt="" />
            <Typography variant="title" color="inherit">
              Adease VOD
            </Typography>
          </Toolbar>
        </AppBar>

        <Grid item xs={12} md={6} className={classes.gridLeft}>
          <Card>
            {this.state.manifestURL === "" ? null : (
              <VideoPlayerSelector
                playerKind={
                  this.props.match.params.player || this.state.playerKind
                }
                manifestURL={this.state.manifestURL}
                timeUpdateCallback={this.timeUpdate}
              />
            )}
          </Card>
        </Grid>

        <Grid item xs={12} md={6} className={classes.gridRight}>
          <AdInfo
            adDuration={this.state.adInfo.adDuration}
            adVendor={this.state.adInfo.adVendor}
          />

          <Beaconing
            beacons={this.state.beacons}
            waitingForAd={this.state.waitingForAd}
          />

          {playerSelector()}

          {videoSelector()}
        </Grid>

        <AppBar className={classes.footer} component="footer">
          <Toolbar className={classes.toolbarFooter}>
            <Typography color="inherit">
              Powered by{" "}
              <img className={classes.footerLogo} src={logo} alt="logo" />
            </Typography>
            <Typography color="inherit">
              © Copyright 2018 Switch Media. All rights reserved
            </Typography>
          </Toolbar>
        </AppBar>
      </Grid>
    );
  }
}

export default withStyles(styles)(App);



// WEBPACK FOOTER //
// ./src/VOD/App.js